<template>
  <div>
    <div v-for="(item, i) in entriesMapped" :key="item.code + i">
      <div class="text-secondary class-show d-flex mb-2 justify-space-between">
        <div>
          <AppShowEntryClassChip :entry="item">
            {{ item.code }}
            {{ item.section ? ` (${item.section})` : "" }}
            {{ item.icelandicDirection ? ` - ${item.icelandicDirection}` : "" }}
          </AppShowEntryClassChip>
          <AppShowEntryOutsideCompetitionChip
            v-if="item.outsideOfCompetition"
            class-list="ml-2"
          />
          <div v-if="item.teamName" class="text-secondary">
            <small>{{ item.teamName }}</small>
          </div>
        </div>

        <div class="align-items d-flex flex-row">
          <AppShowCupSeasons
            v-if="
              item.competition.cupSeasons &&
              item.competition.cupSeasons.length > 0 &&
              showCupSeason
            "
            :cup-seasons="item.competition.cupSeasons"
            variant="text"
            class="text-secondary"
          />

          <AppShowPaymentStatus
            v-if="isFeatureFlagSet('useOnlinePayments')"
            :paid-externally="item.paidExternally"
            :status="item.paymentStatus"
            :ignore="['PAID']"
            small
          />

          <EntryFeiActionsMenu :entry="item.entry" />
        </div>
      </div>
      <slot name="append" :entry="item.entry" />
    </div>
  </div>
</template>
<script>
import { getFederationConfiguration } from "@composables/masterdata/config";
import { useSectionHelper } from "@composables/masterdata/competitions/sections";
import { get } from "lodash-es";
import { useCompetitionHelpers } from "@composables/competition_helpers";

import AppShowEntryClassChip from "@AppShows/event/AppShowEntryClassChip.vue";
import AppShowCompetitionGrandPrix from "@AppShows/event/AppShowCompetitionGrandPrix.vue";
import AppShowPaymentStatus from "@AppShows/AppShowPaymentStatus.vue";
import EntryFeiActionsMenu from "@elements/AppEntryFeiActions/EntryFeiActionsMenu.vue";
import AppShowEntryOutsideCompetitionChip from "@AppShows/event/AppShowEntryOutsideCompetitionChip.vue";

import AppShowCupSeasons from "@AppShows/event/AppShowCupSeasons.vue";

import gql from "fraql";
export default {
  name: "RegistrationClasses",
  components: {
    AppShowPaymentStatus,
    AppShowEntryClassChip,
    EntryFeiActionsMenu,
    //eslint-disable-next-line
    AppShowCompetitionGrandPrix,
    AppShowEntryOutsideCompetitionChip,
    AppShowCupSeasons
  },
  props: {
    entries: {
      type: Array,
      default: () => []
    },
    showCupSeason: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const compHelpers = useCompetitionHelpers();
    return {
      ...useSectionHelper(),
      ...getFederationConfiguration(),
      ...compHelpers
    };
  },
  computed: {
    entriesMapped() {
      return this.competitionsOrdered(
        this.entries.map(entry => {
          return {
            id: entry.id,
            registration: entry.registration,
            competition: entry.competition,
            allowedMutations: entry.allowedMutations,
            code: entry.competition.code,
            late: entry.isLateEntry,

            entry,

            status: entry.status,
            resolution: entry.resolution,
            isGrandPrix: entry.competition.isGrandPrix,
            icelandicDirection: get(
              entry,
              "competition.competitionRule.icelandicDirectionRequired",
              false
            )
              ? entry.icelandicDirection
              : null,
            teamName: entry.competition.isTeamCompetition
              ? entry.teamName
              : null,
            paymentStatus: entry.paymentStatus,
            section: this.getSectionFromMaster(entry.sectionId, "shortName"),
            paidExternally:
              entry.paidExternally || entry.competition.paidExternally,
            outsideOfCompetition: entry.outsideOfCompetition
          };
        })
      );
    }
  },
  fragments: {
    eventFields: gql`
      fragment _ on Event {
        ${EntryFeiActionsMenu.fragments.eventFields}
      }
    `,
    registrationFields: gql`
      fragment _ on Registration {
        ${EntryFeiActionsMenu.fragments.registrationFields}
      }
    `,
    entry: gql`
      fragment _ on Entry {
        id
        teamName
        sectionId
        paymentStatus
        paidExternally
        isLateEntry
        outsideOfCompetition
        ${AppShowEntryClassChip.fragments.entryFields}
        ${EntryFeiActionsMenu.fragments.entryFields}
      }
    `,
    competition: gql`
      fragment _ on Competition {
        id
        code
        paidExternally
        isTeamCompetition
        ${AppShowCompetitionGrandPrix.fragments.grandPrix}
        cupSeasons {
          id
          ${AppShowCupSeasons.fragments.cupSeasonFields}
        }
        competitionRule {
          id
          icelandicDirectionRequired
        }
      }
    `
  }
};
</script>
<style scoped>
.class-show {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.align-items {
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>
